<template>
    <div class="form-filter form-filter--sale">
        <form @submit.prevent="getfilteredData()">
            <b-row>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <!-- Field: Search -->
                    <div class="field-wrap">
                        <label
                            for="field-search-let"
                        >
                            Area Search
                        </label>
                        <div class="field-wrap__input field-wrap__input--prepend field-wrap__input--prepend-fill">
                            <places
                                id="field-search-let"
                                v-model="search_let"
                                :options="{
                                    countries: ['gb'],
                                    language: 'en',
                                    type: 'city',
                                    aroundLatLngViaIP: false,
                                    templates: {
                                        value: function(suggestion) {
                                            return suggestion.name;
                                        }
                                    }
                                }"
                                placeholder="Search by Postcode or Location"
                                name="field-search-let"
                                @change="val => { searchData_let = val }"
                            />
                            <div class="field-wrap__input-icon">
                                <SVGSprite
                                    name="search"
                                    class="form-icon"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- END Field: Search -->
                </b-col>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <b-row>
                        <b-col cols="6">
                            <!-- Field: Min bedrooms -->
                            <div class="field-wrap">
                                <label
                                    for="select-field"
                                >
                                    Min Bedrooms
                                </label>
                                <div class="field-wrap__input field-wrap__input--select">
                                    <select
                                        id="field-min-beds-let"
                                        v-model="min_beds_let"
                                        name="field-min-beds-let"
                                    >
                                        <option
                                            disabled
                                            selected
                                            hidden
                                        >
                                            Select
                                        </option>
                                        <option :value="0">
                                            No Minimum
                                        </option>
                                        <option :value="1">
                                            1
                                        </option>
                                        <option :value="2">
                                            2
                                        </option>
                                        <option :value="3">
                                            3
                                        </option>
                                        <option :value="4">
                                            4
                                        </option>
                                        <option :value="5">
                                            5
                                        </option>
                                        <option :value="6">
                                            6+
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <!-- END Field: Min bedrooms -->
                        </b-col>
                        <b-col cols="6">
                            <!-- Field: Max bedrooms -->
                            <div class="field-wrap">
                                <label
                                    for="field-max-beds-let"
                                >
                                    Max Bedrooms
                                </label>
                                <div class="field-wrap__input field-wrap__input--select">
                                    <select
                                        id="field-max-beds-let"
                                        v-model="max_beds_let"
                                        name="field-max-beds-let"
                                    >
                                        <option
                                            disabled
                                            selected
                                            hidden
                                        >
                                            Select
                                        </option>
                                        <option :value="0">
                                            No Maximum
                                        </option>
                                        <option :value="1">
                                            1
                                        </option>
                                        <option :value="2">
                                            2
                                        </option>
                                        <option :value="3">
                                            3
                                        </option>
                                        <option :value="4">
                                            4
                                        </option>
                                        <option :value="5">
                                            5
                                        </option>
                                        <option :value="6">
                                            6+
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <!-- END Field: Max bedrooms -->
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>


            <b-row>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <b-row>
                        <b-col
                            cols="12"
                            lg="6"
                        >
                            <!-- Field: Min PCM -->
                            <div class="field-wrap">
                                <label
                                    for="field-min-pcm"
                                >
                                    Min PCM
                                </label>
                                <div class="field-wrap__input field-wrap__input--select">
                                    <select
                                        id="field-min-pcm"
                                        v-model="min_pcm"
                                        name="field-min-pcm"
                                    >
                                        <option
                                            disabled
                                            selected
                                            hidden
                                            value=""
                                        >
                                            Select
                                        </option>
                                        <option :value="0">
                                            No Minimum
                                        </option>
                                        <option
                                            v-for="n in 40"
                                            :key="n"
                                            :value="(n * 100)"
                                        >
                                            {{ (n * 100) | price(false) }} PCM
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <!-- END Field: Min PCM -->
                        </b-col>
                        <b-col
                            cols="12"
                            lg="6"
                        >
                            <!-- Field: Max PCM -->
                            <div class="field-wrap">
                                <label
                                    for="field-max-pcm"
                                >
                                    Max PCM
                                </label>
                                <div class="field-wrap__input field-wrap__input--select">
                                    <select
                                        id="field-max-pcm"
                                        v-model="max_pcm"
                                        name="field-max-pcm"
                                    >
                                        <option
                                            disabled
                                            selected
                                            hidden
                                            value=""
                                        >
                                            Select
                                        </option>
                                        <option :value="0">
                                            No Maximum
                                        </option>
                                        <option
                                            v-for="n in 40"
                                            :key="n"
                                            :value="(n * 100)"
                                        >
                                            {{ (n * 100) | price(false) }} PCM
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <!-- END Field: Max PCM -->
                        </b-col>
                    </b-row>
                </b-col>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <div class="d-flex justify-content-lg-end">
                        <!-- Field: Checkbox -->
                        <div class="field-wrap w-auto">
                            <div class="field-wrap__input field-wrap__input--checkbox">
                                <input
                                    id="field-checkbox-let"
                                    v-model="toggle_let"
                                    type="checkbox"
                                    true-value="true"
                                    false-value="false"
                                    name="field-checkbox-let"
                                >
                                <label for="field-checkbox-let"><span class="check-element" />Include Let Agreed</label>
                            </div>
                        </div>
                        <!-- Field: Checkbox -->
                    </div>

                    <div class="d-flex justify-content-between justify-content-lg-end">
                        <!-- Clear filter -->
                        <button
                            type="button"
                            class="btn btn--nomin btn--outline mt-4 mr-2 mt-md-0"
                            @click="clearFilters()"
                        >
                            Clear Filters
                        </button>
                        <!-- END Clear filter -->

                        <!-- Submit filter -->
                        <button
                            type="submit"
                            class="btn btn--secondary mt-4 mt-md-0"
                        >
                            Search Properties
                        </button>
                        <!-- END Submit filter -->
                    </div>
                </b-col>
            </b-row>
        </form>
    </div>
</template>

<script>
import Places from 'vue-places';

export default {
    name: 'SearchLetForm',
    components: {
        Places
    },
    data() {
        return {
            search_let: null,
            searchData_let: {},
            min_beds_let: 0,
            max_beds_let: 0,
            min_pcm: 0,
            max_pcm: 4000,
            toggle_let: false
        };
    },
    methods: {
        // Get the filtered data and emit to parent component
        getfilteredData() {
            const filters = {
                type: 'rent',
                search: this.search_let,
                min_beds: this.min_beds_let,
                max_beds: this.max_beds_let,
                min_pcm: parseFloat(this.min_pcm) || null,
                max_pcm: parseFloat(this.max_pcm) || null,
                toggle: this.toggle_let
            };
            this.$emit('filterPropertiesLet', filters);
        },
        clearFilters() {
            this.search_let = null;
            this.min_beds_let = 0;
            this.max_beds_let = 0;
            this.min_pcm = 0;
            this.max_pcm = 4000;
            this.toggle_let = null;
            this.$emit('filterPropertiesLet', {});
        }
    }
};
</script>

<style lang="scss">

</style>
